// ** global usage
import { LayoutService } from './layout.service';

// ** primeNg
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

// ** 靜態資料呼叫的 service
import { HomeService } from './home.service';
import { NewsService } from './news.service';
import { ProductsService } from './products.service';
import { SuccessService } from './success.service';

// ** 資料庫 service(supabase)
import { SupabaseService } from './supabase.service';

export const services = [
	HomeService,
	MessageService,
	ConfirmationService,
	DialogService,
	LayoutService,
	NewsService,
	ProductsService,
	SuccessService,
	SupabaseService
];

export * from './home.service';
export * from 'primeng/api';
export * from './supabase.service';
